import Vue from 'vue'
import 'vue-material/dist/vue-material.min.css'

  import  { MdField,MdButton } from 'vue-material/dist/components'

    Vue.use(MdField)

    Vue.use(MdButton)
